// Runtime configuration loaded from /config.json
// This file is generated at container startup from environment variables

export interface AppConfig {
  apiUrl: string;
  baseApiUrl: string; // Base URL without /api/v1/crs-portal suffix (for translations)
  keycloakAuthority: string;
  keycloakClientId: string;
}

let config: AppConfig | null = null;

/**
 * Load configuration from /config.json (production) or environment variables (development)
 * This must be called before making API calls
 * @returns Promise<AppConfig> The loaded configuration
 */
export async function loadConfig(): Promise<AppConfig> {
  if (config) {
    return config;
  }

  try {
    // Try to load from /config.json (production/Docker)
    const response = await fetch("/config.json");

    if (response.ok && response.headers.get("content-type")?.includes("application/json")) {
      const loadedConfig = await response.json();
      // Derive baseApiUrl if not provided
      config = {
        ...loadedConfig,
        baseApiUrl:
          loadedConfig.baseApiUrl || loadedConfig.apiUrl.replace(/\/api\/v1\/crs-portal$/, ""),
        keycloakAuthority:
          loadedConfig.keycloakAuthority ||
          import.meta.env.VITE_KEYCLOAK_AUTHORITY ||
          "http://localhost:9080/realms/xchange-external",
        keycloakClientId: loadedConfig.keycloakClientId || "crs-portal",
      };
      console.log("✓ Runtime configuration loaded from /config.json");
      return config;
    }
  } catch {
    console.warn("config.json not found, falling back to environment variables (development mode)");
  }

  // Fallback to environment variables (development with Vite)
  const apiUrl = import.meta.env.VITE_API_URL || "https://xchange.localhost:9443/api/v1/crs-portal";
  config = {
    apiUrl,
    baseApiUrl: import.meta.env.VITE_BASE_API_URL || "https://xchange.localhost:9443",
    keycloakAuthority:
      import.meta.env.VITE_KEYCLOAK_AUTHORITY || "http://localhost:9080/realms/xchange-external",
    keycloakClientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID || "crs-portal",
  };

  console.log("✓ Configuration loaded from environment variables");
  return config;
}

/**
 * Get the loaded configuration
 * @throws Error if config hasn't been loaded yet
 * @returns AppConfig The loaded configuration
 */
export function getConfig(): AppConfig {
  if (!config) {
    throw new Error("Configuration not loaded. Call loadConfig() before using getConfig().");
  }
  return config;
}

/**
 * Check if configuration has been loaded
 * @returns boolean True if config is loaded
 */
export function isConfigLoaded(): boolean {
  return config !== null;
}
